import { render } from "./RolePermissionsEditor.vue?vue&type=template&id=0b445278&scoped=true"
import script from "./RolePermissionsEditor.vue?vue&type=script&lang=js"
export * from "./RolePermissionsEditor.vue?vue&type=script&lang=js"

import "./RolePermissionsEditor.vue?vue&type=style&index=0&id=0b445278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b445278"]])

export default __exports__